import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { changePassword2 } from '@/services/authService';
import Label from '@/components/form/Label/Label';
import emailjs from '@emailjs/browser';
import fondo from '../style/_assets/img/fondo3.png';

const NuevaContrasenaModal = ({ open, onBack }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [generatedPassword, setGeneratedPassword] = useState('');
  const generatePassword = (length = 10) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
    let password = '';

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      password += chars[randomIndex];
    }

    return password;
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      document: '',
    },
    onSubmit: async (values) => {
      if (!values.email || !values.document) {
        setErrorMessage('Todos los campos son obligatorios');
        setTimeout(() => setErrorMessage(''), 3000);
        return;
      }

      const newPassword = generatePassword(10);

      const payload = {
        correo_electronico: values.email,
        numero_de_dni: values.document,
        repeat_pass: newPassword,
        modo: 'CAMBIAR',
      };

      try {
        const response = await changePassword2(payload);
        console.log('RESPUESTA BACKEND:', response);

        const templateParams = {
          user_name: 'Usuario',
          reply_to: payload.correo_electronico,
          copy_to: payload.correo_electronico,
          message:
            'Estimado usuario ' +
            payload.numero_de_dni +
            ' esta es su nueva contraseña autogenerada: ' +
            newPassword,
        };

        emailjs
          .send('service_zdu3k6p', 'template_3zc9p4j', templateParams, 'SuYqnE4z3_IEWAh90')
          .then(
            (response) => {
              console.log('ÉXITO!', response.status, response.text);
            },
            (err) => {
              console.log('FALLÓ...', err);
            },
          );
        setGeneratedPassword(newPassword);
        setSuccessMessage('Contraseña generada y actualizada correctamente');
        setErrorMessage('');
        formik.resetForm();
      } catch (error) {
        console.error('ERROR BACKEND:', error);
        setErrorMessage(
          'Los datos ingresados no son correctos, contáctese con el Centro Dr. Q, Para recibir ayuda',
        );
        setTimeout(() => setErrorMessage(''), 3500);
      }
    },
  });

  useEffect(() => {
    if (open) {
      formik.resetForm();
      setErrorMessage('');
      setSuccessMessage('');
      setGeneratedPassword('');
    }
  }, [open]);

  if (!open) return null;

  return (
    <FlexContainer
      className={'pos-fixed justify-center align-items-center'}
      style={{
        inset: 0,
        minHeight: '100vh',
        zIndex: 9999,
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${fondo})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          filter: 'blur(5px)',
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.65)',
          zIndex: 2,
        }}
      />
      <form
        onSubmit={formik.handleSubmit}
        className={'pos-rel bgBlue400-2'}
        style={{
          borderRadius: '10px',
          padding: '28px',
          width: '360px',
          zIndex: 5,
          boxShadow: '0px 4px 20px rgba(0,0,0,0.25)',
        }}
      >
        <FlexContainer className={'justify-center margb12'}>
          <img src="/Logotipo_Centro_Blanco2.png" alt="logo" style={{ width: '190px' }} />
        </FlexContainer>

        <Label className={'text-18 font-bold margb16 text-center fontWhite'}>
          Nueva contraseña
        </Label>

        <FlexContainer className="flex-column align-items-center">
          <FlexContainer className="flex-column justify-between width100 margb8 gap-8 marglr10">
            <input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              placeholder="Correo electrónico"
              className="borderrad4 padtb8"
              style={{
                width: '100%',
                border: '1px solid #D0D5DD',
              }}
            />

            <input
              type="text"
              name="document"
              value={formik.values.document}
              onChange={formik.handleChange}
              placeholder="N° documento"
              className="borderrad4 padtb8"
              style={{
                width: '100%',
                border: '1px solid #D0D5DD',
              }}
            />
          </FlexContainer>

          <button
            type="submit"
            className="padtb10 margt16 pointer borderNone"
            style={{
              width: '100%',
              maxWidth: '300px',
              background: 'white',
              color: '#023B7A',
              fontWeight: 600,
              borderRadius: '18px',
            }}
          >
            GENERAR NUEVA CONTRASEÑA
          </button>

          {generatedPassword && (
            <div
              style={{
                background: '#E3F2FD',
                color: '#0D47A1',
                padding: '10px 12px',
                borderRadius: '8px',
                fontSize: '14px',
                textAlign: 'center',
                marginTop: '14px',
                fontWeight: 600,
              }}
            >
              Su nueva contraseña fué generada. Ingrese a su correo electrónico para ver su nueva
              contraseña <br />
            </div>
          )}

          <button
            type="button"
            onClick={onBack}
            className="padtb10 margt12 pointer"
            style={{
              width: '100%',
              maxWidth: '300px',
              background: 'transparent',
              border: '2px solid white',
              color: 'white',
              fontWeight: 600,
              borderRadius: '18px',
            }}
          >
            ← REGRESAR
          </button>
          {errorMessage && (
            <div
              style={{
                background: '#FFE5E5',
                color: '#C62828',
                padding: '8px 12px',
                borderRadius: '6px',
                fontSize: '13px',
                textAlign: 'center',
                marginBottom: '6px',
                marginTop: '12px',
                animation: 'fadeIn 0.3s ease-in-out',
              }}
            >
              {errorMessage}
            </div>
          )}
          {successMessage && (
            <div
              style={{
                background: '#E8F5E9',
                color: '#2E7D32',
                padding: '8px 12px',
                borderRadius: '6px',
                fontSize: '13px',
                textAlign: 'center',
                marginBottom: '6px',
                marginTop: '12px',
                animation: 'fadeIn 0.3s ease-in-out',
              }}
            >
              {successMessage}
            </div>
          )}
        </FlexContainer>
      </form>
    </FlexContainer>
  );
};

export default NuevaContrasenaModal;
